const ENV = process.env.GATSBY_ENV || `development`;

export const ALGOLIA_JOB_SEARCH_INDEX = `job-posts-${ENV}`;

export const ALGOLIA_STORYBLOK_SEARCH_INDEX = `all-storyblok-entries-${ENV}`;
